import {
  put,
  takeEvery,
  //  ,  throttle, select
} from 'redux-saga/effects'

import { Game } from '../../Core'
import PointsAlert from './PointsAlert'
import * as actions from './pointsManager.actions'
import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'

const delay = (ms) => new Promise((res) => setTimeout(res, ms))
/**
 *  Init module.
 */
function* init() {
  yield loadComponents()
}

/** loadComponents **/
export function* loadComponents() {
  const components = {
    PointsAlert,
  }
  yield put(Game.actions.registerComponents(components))
}

/*
icon='icon-coin' points='324' style={{}}

*/
function* showPointsData() {
  yield put(audioActions.playHowlAudio('coin'))
  yield delay(2000)
  yield put(actions.resetPointsData())
}

/**
 *  Calendar sagas entrypoint
 */
export function* sagas() {
  yield init()
  yield takeEvery(actions.SET_POINTS_DATA, showPointsData)
}
